<ul class="context-menu__list">
  <ng-content></ng-content>
</ul>
